// extracted by mini-css-extract-plugin
export default {"container":"dOUbG","isAnimated":"EA4QM","thumbnail":"vCxAh","timeText":"UXsyO"};